import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  // whitespace-nowrap: a two-word status ("API Received") broke across two
  // lines in a narrow table column and dragged the whole row's height with it.
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary/20 text-foreground',
        accent: 'border-accent/40 bg-accent/15 text-foreground',
        outline: 'border-border text-muted-foreground',
        warning: 'border-warning/50 bg-warning/15 text-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export function Badge({
  className,
  variant,
  ...props
}: ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
